import { cn } from "@/lib/utils"

interface StatsCardProps {
  title: string
  value: string | number
  unit?: string
  subtitle?: string
  className?: string
  valueColor?: string
}

export function StatsCard({
  title,
  value,
  unit,
  subtitle,
  className,
  valueColor = "text-brand-primary",
}: StatsCardProps) {
  return (
    <div className={cn("bg-white rounded-lg border border-gray-200 p-4", className)}>
      <h4 className="font-semibold text-gray-600 mb-3 text-center">{title}</h4>

      {/* Horizontal divider */}
      <hr className="border-gray-300 mb-3" />

      {/* Right-aligned values */}
      <div className="text-right space-y-1">
        <p className={cn("text-2xl font-medium", valueColor)}>
          {value} 
          <span className="ms-1 text-sm text-gray-500 font-normal">{unit}</span>
        </p>
        {subtitle && (
          <p className="text-lg font-medium text-gray-600">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  )
}
